import { createSelector } from 'reselect';
import { getLocation } from 'connected-react-router';
import { getRouteMatchForURL } from 'components/Routes';

export const getRoute = createSelector(getLocation, ({ pathname }) => getRouteMatchForURL(pathname));
